import { render, staticRenderFns } from "./EmbeddedAppDelegatorIframe.vue?vue&type=template&id=1bb76bf7&scoped=true"
import script from "./EmbeddedAppDelegatorIframe.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppDelegatorIframe.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppDelegatorIframe.vue?vue&type=style&index=0&id=1bb76bf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb76bf7",
  null
  
)

export default component.exports